import { render, staticRenderFns } from "./dsdjgs.vue?vue&type=template&id=17a32b28&scoped=true&"
import script from "./dsdjgs.vue?vue&type=script&lang=js&"
export * from "./dsdjgs.vue?vue&type=script&lang=js&"
import style0 from "./dsdjgs.vue?vue&type=style&index=0&id=17a32b28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a32b28",
  null
  
)

export default component.exports